<template>
  <div class="cal-activitati-container">
    <!-- Header -->
    <!-- <div class="cal-header">
      <div class="header-left">
        <h1 class="header-title">Calendar Activități CRM</h1>
        <p class="header-subtitle text-medium-emphasis">Gestionează și urmărește activitățile echipei tale</p>
      </div>
      <div class="header-right">
        <v-btn :color="APP_Color" prepend-icon="mdi-refresh" variant="tonal" rounded="lg" class="px-6" @click="refresh">
          Actualizează
        </v-btn>
      </div>
    </div> -->

    <!-- Quick Stats - Premium KPIs -->
    <!-- <div class="stats-grid">
      <div v-for="stat in quickStats" :key="stat.label" class="kpi-tile glass-card">
        <div class="kpi-icon-box" :style="{ background: stat.bgColor }">
          <v-icon :color="stat.color" size="24">{{ stat.icon }}</v-icon>
        </div>
        <div class="kpi-details">
          <span class="kpi-value text-grey-darken-4">{{ stat.value }}</span>
          <span class="kpi-label uppercase-label">{{ stat.label }}</span>
        </div>
        <div class="kpi-visual">
          <div class="visual-bar" :style="{ background: stat.color, height: '4px', width: '30px' }"></div>
        </div>
      </div>
    </div> -->

    <!-- Calendar Card -->
    <v-card class="cal-card glass-card flex-grow-1" border>
      <v-card-title class="cal-card-header d-flex align-center px-6 py-4">
        <div class="d-flex align-center">
          <div class="header-icon-ring mr-3">
            <v-icon :color="APP_Color" size="20">mdi-calendar-account</v-icon>
          </div>
          <span class="font-weight-bold">Program Activități</span>
        </div>
        <v-spacer />
        <!-- Integrated and specialized switch -->
        <div class="integrated-toggle glass-pill">
          <v-switch v-model="doarAleMele" label="Doar ale mele" :color="APP_Color" hide-details density="compact"
            class="small-switch" @update:model-value="onFilterChange" />
        </div>
      </v-card-title>

      <v-card-text class="pa-0 scheduler-wrapper">
        <DxScheduler ref="schedulerRef" time-zone="Europe/Bucharest" :data-source="dataSource" height="100%"
          :views="views" current-view="month" :current-date="currentDate"
          date-serialization-format="yyyy-MM-ddTHH:mm:ssZ" start-date-expr="Data" end-date-expr="EndData"
          text-expr="Subject" :start-day-hour="8" :end-day-hour="20" :show-appointment-tooltip="false"
          :editing="editingConfig" @appointment-click="onAppointmentClick"
          @appointment-form-opening="onAppointmentFormOpening">
          <DxLoadPanel :enabled="true" />
        </DxScheduler>
      </v-card-text>
    </v-card>

    <!-- Details Popup -->
    <DxPopup v-model:visible="detailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
      :show-close-button="true" :width="750" height="450" class="premium-popup">
      <template #title>
        <div class="popup-header popup-header--activity">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-task"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">{{ selectedActivity?.TipActivitate?.Nume || 'Activitate CRM' }}</div>
            </div>
          </div>
        </div>
      </template>

      <DxScrollView width="100%" height="auto" class="details-scroll-view">
        <div class="details-container" v-if="selectedActivity">
          <!-- Quick Stats Row -->
          <div class="stats-grid-details">

            <div class="stat-card stat-card--date">
              <div class="stat-icon dx-icon-event"></div>
              <div class="stat-content">
                <div class="stat-label">Data Planificată</div>
                <div class="stat-value">{{ formatDate(selectedActivity.Data) }}</div>
              </div>
            </div>
          </div>

          <!-- Main Info Grid -->
          <div class="info-sections-grid">
            <!-- Left Column: Context -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-link section-icon"></span>
                  <span>Context Activitate</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Partener</label>
                    <div class="value">{{ selectedActivity.Account?.Nume || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Responsabil</label>
                    <div class="value">{{ selectedActivity.Owner || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Right Column: Details -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-doc section-icon"></span>
                  <span>Descriere & Note</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Descriere Detaliată</label>
                    <div class="value multiline">{{ selectedActivity.Descriere || '-' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DxScrollView>
    </DxPopup>

    <!-- Add Activity Popup -->
    <DxPopup v-model:visible="addVisible" :close-on-outside-click="false" :show-close-button="false" :show-title="true"
      :width="700" :height="550" class="premium-popup">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare activitate</div>
              <div class="popup-header-subtitle">
                Completează informațiile de mai jos
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nouă
            </span>
          </div>
        </div>
      </template>

      <div class="popup-body-simple popup-body-modern">
        <DxScrollView height="100%" width="100%">
          <div class="form-content form-content-modern">
            <DxForm :form-data="addFormData" :col-count="2" label-location="top">

              <DxFormItem :col-span="2" :label="{ text: 'Tip Activitate' }">
                <DxRequiredRule message="Câmpul 'Tip Activitate' este obligatoriu" />
                <DxDropDownBox v-model:opened="isTipActivitateGridBoxOpened" :data-source="tipActivitateSelectat"
                  v-model:value="sTipActivitate" :show-clear-button="true" display-expr="Nume" value-expr="ID">
                  <template #content>
                    <DxDataGrid :data-source="dsTipActivitati" :columns="['Nume']" :hover-state-enabled="true"
                      :height="250" @selection-changed="onValueSelectedTipActivitate">
                      <DxSelection mode="single" />
                      <DxScrolling mode="virtual" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem :col-span="2" :label="{ text: 'Partener' }">
                <DxDropDownBox v-model:opened="isParteneriGridBoxOpened" :data-source="partenerSelectat"
                  v-model:value="sPartener" :show-clear-button="true" display-expr="Nume" value-expr="ID">
                  <template #content>
                    <DxDataGrid :data-source="dsParteneri" :columns="['Nume']" :hover-state-enabled="true" :height="250"
                      @selection-changed="onValueSelectedPartener">
                      <DxSelection mode="single" />
                      <DxScrolling mode="virtual" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem data-field="Data" :col-span="2" editor-type="dxDateBox" :editor-options="{
                displayFormat: 'dd/MM/yyyy',
                type: 'datetime',
                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ'
              }" />

              <DxFormItem data-field="Descriere" :col-span="2" editor-type="dxTextArea"
                :editor-options="{ height: 120 }">
                <DxRequiredRule message="Câmpul 'Descriere' este obligatoriu" />
              </DxFormItem>

            </DxForm>
          </div>
        </DxScrollView>

        <div class="form-footer footer-fixed footer-modern">
          <div class="footer-left"></div>
          <div class="footer-right">
            <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
              :disabled="isSaving" @click="saveActivity" />
            <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined"
              @click="addVisible = false" />
          </div>
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DxScheduler from 'devextreme-vue/scheduler';
import { DxLoadPanel, DxDataGrid, DxSelection, DxScrolling, DxFilterRow, DxSearchPanel } from 'devextreme-vue/data-grid';
import DxPopup from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem, DxRequiredRule } from 'devextreme-vue/form';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxButton } from 'devextreme-vue/button';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import JwtServices from '@/services/JwtServices';
import http from '@/settings/apiSettings';
import CrmActivitati from '@/services/Comercial/CrmActivitati';
import notify from 'devextreme/ui/notify';
import { loadMessages, locale } from 'devextreme/localization';

export default defineComponent({
  name: 'CalendarActivitati',
  components: {
    DxScheduler, DxLoadPanel,
    DxPopup, DxScrollView,
    DxForm, DxFormItem, DxRequiredRule,
    DxDropDownBox,
    DxDataGrid, DxSelection, DxScrolling, DxFilterRow, DxSearchPanel,
    DxButton,
  },
  data() {
    return {
      APP_Color: AppSetting.APP_Color || '#1976D2',
      views: ['day', 'week', 'month', 'agenda'],
      currentDate: new Date(),
      dataSource: null as any,
      doarAleMele: false,
      detailsVisible: false,
      selectedActivity: null as any,
      editingConfig: {
        allowAdding: true,
        allowUpdating: false,
        allowDeleting: false,
      },
      // Add form
      addVisible: false,
      isSaving: false,
      addFormData: {
        Data: new Date() as Date,
        Descriere: '',
      } as any,
      // TipActivitate dropdown
      sTipActivitate: null as string | null,
      tipActivitateSelectat: [] as any[],
      isTipActivitateGridBoxOpened: false,
      // Partener dropdown
      sPartener: null as string | null,
      partenerSelectat: [] as any[],
      isParteneriGridBoxOpened: false,
      // Lookup sources
      dsTipActivitati: null as any,
      dsParteneri: null as any,
      quickStats: [
        { label: 'Astăzi', value: '-', icon: 'mdi-calendar-today', color: '#ff5722', bgColor: 'rgba(255,87,34,0.1)' },
        { label: 'Săptămână', value: '-', icon: 'mdi-calendar-week', color: '#2196F3', bgColor: 'rgba(33,150,243,0.1)' },
        { label: 'Luna aceasta', value: '-', icon: 'mdi-calendar-month', color: '#4CAF50', bgColor: 'rgba(76,175,80,0.1)' },
        { label: 'Viitoare', value: '-', icon: 'mdi-calendar-clock', color: '#9C27B0', bgColor: 'rgba(156,39,176,0.1)' },
      ],
    };
  },
  mounted() {
    loadMessages(require('devextreme/localization/messages/ro.json'));
    locale('ro');
    this.buildDataSource();
    this.buildLookups();
    this.loadStats();
  },
  methods: {
    buildDataSource() {
      const username = JwtServices.GetUsername();
      const doarAleMele = this.doarAleMele;
      this.dataSource = new DataSource({
        store: new ODataStore({
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Activitati',
          key: 'ID',
          version: 4,
          beforeSend(e: any) {
            e.headers = {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            };
            e.params['$expand'] = 'TipActivitate,Account';
          },
        }),
        filter: doarAleMele ? ['Owner', '=', username] : undefined,
        postProcess(items: any[]) {
          return items.map(item => ({
            ...item,
            EndData: item.Data
              ? new Date(new Date(item.Data).getTime() + (item.Durata || 60) * 60000)
              : null,
            Subject: [item.TipActivitate?.Nume, item.Account?.Nume]
              .filter(Boolean).join(' — ') || item.Descriere || 'Activitate',
          }));
        },
      });
    },

    buildLookups() {
      const makeStore = (url: string, key: string, selectFields: string[]) =>
        new DataSource({
          store: {
            type: 'odata',
            url: AppSetting.API_Url_ComercialOdata + url,
            key,
            keyType: 'Guid',
            version: 4,
            fieldTypes: { [key]: 'Guid' },
            beforeSend: (e: any) => {
              e.headers = {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
              };
            },
          },
          select: selectFields,
        });

      this.dsTipActivitati = makeStore('CRM_CautareTipuriActivitati', 'ID', ['ID', 'Nume']);
      this.dsParteneri = makeStore('PAR_Parteneri', 'ID', ['ID', 'Nume']);
    },

    onFilterChange() { this.buildDataSource(); },

    refresh() {
      this.dataSource?.reload();
      this.loadStats();
    },

    onAppointmentClick(e: any) {
      e.cancel = true;
      this.selectedActivity = e.appointmentData;
      this.detailsVisible = true;
    },

    onAppointmentFormOpening(e: any) {
      e.cancel = true;
      const startDate = e.appointmentData?.startDate || new Date();
      this.addFormData = { Data: new Date(startDate), Descriere: '' };
      this.sTipActivitate = null;
      this.tipActivitateSelectat = [];
      this.sPartener = null;
      this.partenerSelectat = [];
      this.addVisible = true;
    },

    onValueSelectedTipActivitate(e: any) {
      this.isTipActivitateGridBoxOpened = false;
      if (e.selectedRowKeys?.length > 0) {
        this.sTipActivitate = e.selectedRowKeys[0];
        this.tipActivitateSelectat = e.selectedRowsData;
      } else {
        this.sTipActivitate = null;
      }
    },

    onValueSelectedPartener(e: any) {
      this.isParteneriGridBoxOpened = false;
      if (e.selectedRowKeys?.length > 0) {
        this.sPartener = e.selectedRowKeys[0];
        this.partenerSelectat = e.selectedRowsData;
      } else {
        this.sPartener = null;
      }
    },

    async saveActivity() {
      if (!this.sTipActivitate) {
        notify('Câmpul "Tip Activitate" este obligatoriu!', 'error', 2000);
        return;
      }
      if (!this.addFormData.Descriere?.trim()) {
        notify('Câmpul "Descriere" este obligatoriu!', 'error', 2000);
        return;
      }
      this.isSaving = true;
      try {
        await CrmActivitati.save({
          TipActivitateID: this.sTipActivitate,
          AccountID: this.sPartener || null,
          Data: this.addFormData.Data,
          Descriere: this.addFormData.Descriere.trim(),
          Owner: JwtServices.GetUsername(),
          UserCreat: JwtServices.GetUsername(),
          DataCreat: new Date(),
          Globala: false,
        });
        notify('Activitate salvată!', 'success', 1500);
        this.addVisible = false;
        this.dataSource?.reload();
        this.loadStats();
      } catch {
        notify('Eroare la salvarea activității!', 'error', 2000);
      } finally {
        this.isSaving = false;
      }
    },

    formatDate(dateStr: string | null): string {
      if (!dateStr) return '-';
      return new Date(dateStr).toLocaleString('ro-RO', {
        day: '2-digit', month: '2-digit', year: 'numeric',

      });
    },

    formatCurrency(value: any, valuta: any): string {
      if (value === null || value === undefined) return '-';
      const formatted = Number(value).toLocaleString('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const simbol = valuta?.Simbol || 'RON';
      return `${formatted} ${simbol}`;
    },

    async loadStats() {
      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
      const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).toISOString();
      const dow = now.getDay();
      const diffToMonday = dow === 0 ? -6 : 1 - dow;
      const weekStart = new Date(now);
      weekStart.setDate(now.getDate() + diffToMonday);
      weekStart.setHours(0, 0, 0, 0);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 7);
      const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
      const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 1).toISOString();
      const futureStart = now.toISOString();
      const auth = 'Bearer ' + localStorage.getItem('ERA_Jwt');
      const makeUrl = (f: string) => `CRM_Activitati?$count=true&$top=0&$filter=${encodeURIComponent(f)}`;
      try {
        const [r1, r2, r3, r4] = await Promise.all([
          http.clientComercialOdata.get(makeUrl(`Data ge ${todayStart} and Data lt ${todayEnd}`), { headers: { Authorization: auth } }),
          http.clientComercialOdata.get(makeUrl(`Data ge ${weekStart.toISOString()} and Data lt ${weekEnd.toISOString()}`), { headers: { Authorization: auth } }),
          http.clientComercialOdata.get(makeUrl(`Data ge ${monthStart} and Data lt ${monthEnd}`), { headers: { Authorization: auth } }),
          http.clientComercialOdata.get(makeUrl(`Data ge ${futureStart}`), { headers: { Authorization: auth } }),
        ]);
        this.quickStats[0].value = String(r1.data['@odata.count'] ?? '-');
        this.quickStats[1].value = String(r2.data['@odata.count'] ?? '-');
        this.quickStats[2].value = String(r3.data['@odata.count'] ?? '-');
        this.quickStats[3].value = String(r4.data['@odata.count'] ?? '-');
      } catch { /* stats rămân '-' */ }
    },
  },
});
</script>

<style scoped>
.cal-activitati-container {
  padding: 1.5rem;
  background: radial-gradient(circle at top right, #fcfcfc, #f3f4f6);
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 1.5rem;
}

.cal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.header-title {
  font-size: 1.75rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin-bottom: 0.25rem;
}

.header-subtitle {
  font-size: 0.95rem;
  margin: 0;
}

/* KPI Tiles Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.kpi-tile {
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.kpi-tile:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
}

.kpi-icon-box {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-details {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.kpi-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.kpi-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #64748b;
  margin-top: 0.25rem;
}

.kpi-trend,
.kpi-visual {
  width: 60px;
  display: flex;
  justify-content: flex-end;
  opacity: 0.6;
}

.visual-bar {
  border-radius: 10px;
}

/* Glassmorphism Classes */
.glass-card {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.8) !important;
  border-radius: 20px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05) !important;
}

.glass-pill {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(4px);
  padding: 2px 12px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* Calendar Card */
.scheduler-wrapper {
  flex: 1;
  position: relative;
}

.header-icon-ring {
  width: 36px;
  height: 36px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Integrated Toggle Styling */
.small-switch :deep(.v-label) {
  font-size: 0.8rem !important;
  font-weight: 600;
  color: #475569;
}

.small-switch :deep(.v-selection-control) {
  min-height: 32px;
}

/* Scheduler Overrides */
:deep(.dx-scheduler-work-space) {
  background: transparent !important;
}

:deep(.dx-scheduler-header) {
  background: transparent !important;
  border: none !important;
  padding: 8px 16px;
}

:deep(.dx-scheduler-appointment) {
  border-radius: 8px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: none !important;
}

/* Dialog & Popup Styling */
.premium-dialog-card {
  border-radius: 24px !important;
}

.dialog-header-gradient {
  position: relative;
}

.list-icon-bg {
  width: 36px;
  height: 36px;
  background: #f1f5f9;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

/* Footer Styling */
.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

/* Base popup styles from card-activity.vue */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
  width: 100%;
}

.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.popup-header-icon {
  font-size: 20px;
}

.popup-header-texts {
  display: flex;
  flex-direction: column;
}

.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}

.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.popup-header-meta {
  display: flex;
  align-items: center;
}

/* Status Chips */
.status-chip {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);

  &--draft {
    background: #fef3c7;
    color: #92400e;
    border-color: #fcd34d;
  }
}

.popup-body-simple {
  background: white;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.popup-body-modern {
  padding: 14px 18px 56px 18px;
}

.details-scroll-view {
  background-color: #f8f9fc;
}

.details-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Context */
.popup-header--activity {
  background: linear-gradient(90deg, #ff2c21, #ff6a4a) !important;
}

/* Details Stats Grid */
:deep(.dx-popup-content) {
  padding: 0 !important;
}

.stats-grid-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.stat-card {
  background: white;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
}

.stat-card--cost .stat-icon {
  background: #ecfdf5;
  color: #059669;
}



.stat-card--date .stat-icon {
  background: #fdf2f8;
  color: #db2777;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  font-weight: 600;
}

.stat-value {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  margin-top: 2px;
}

/* Info Sections */
.info-sections-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 14px 16px;
  background: #fcfcfd;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: #334155;
  font-size: 14px;
}

.section-icon {
  color: #64748b;
  font-size: 18px;
}

.info-list {
  padding: 8px 0;
}

.info-item {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item label {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  font-weight: 600;
}

.info-item .value {
  font-size: 14px;
  color: #334155;
  font-weight: 500;
}

.info-item .value.multiline {
  line-height: 1.5;
  font-style: italic;
  color: #475569;
}

/* Status Chips Variants */
.status-chip--global {
  background: #fef3c7 !important;
  color: #92400e !important;
  border-color: #fcd34d !important;
}

.status-chip--local {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-color: #cbd5e1 !important;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f8fafc;
  z-index: 10;
}

.footer-right .dx-button {
  margin-left: 8px;
}

.uppercase-label {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.line-height-relaxed {
  line-height: 1.6;
}

@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .cal-activitati-container {
    height: auto;
    overflow-y: auto;
  }
}
</style>
